<template>

    <div>

        <div class="row row-cols-1 g-4 mb-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Message') }}</legend>
                            <select-input label="message_type" v-model="form.message_type" :error="form.errors.message_type">
                                <option :value="null">{{ __('Please select') }}</option>
                                <option :value="k" v-for="(v, k) in messageTypeOptions">{{ v }}</option>
                            </select-input>
                            <text-input label="subject" v-model="form.subject" :error="form.errors.subject" />
                            <editor-input label="text" v-model="form.text" :error="form.errors.text" />

                            <div class="alert alert-primary">
                                <checkbox-input 
                                    label="send_message" 
                                    v-model="form.send_message" 
                                    :error="form.errors.send_message"
                                    :help="__('Auswählen, um die Nachricht wirklich zu verschicken')"
                                    />
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
            </div>

        </div>

    </div>

</div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import EditorInput from '@/shared/Inputs/EditorInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'message',
            'messageTypeOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            EditorInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {

        },
    }
</script>
